// extracted by mini-css-extract-plugin
module.exports = {"hero_container":"Hero_hero_container__1xJ6l","overlay":"Hero_overlay__2hfiQ","logo":"Hero_logo__21q0n","main_heading":"Hero_main_heading__2tE-P"};